import { PDF_COLORS, lineLayoutsV2, pdfFz } from "./stylesPDFv2";
import { kvRows } from "./PDFKeyValue";
import { qrCanvasNode } from "./PDFQr";

/**
 * @param {object} params
 * @param {object} params.dataExtra (uuid, selloCFDI, selloSAT, noCertificadoCFDI,
 *   noCertificadoSAT, cadenaOriginalSAT, fechaTimbrado)
 * @param {object} params.dataSat   para fallback de fecha
 * @param {string} params.qrLink    URL del QR de validación del SAT
 * @returns nodo pdfMake (stack)
 */
export const PDFCfdiFooterV2 = ({ dataExtra = {}, dataSat = {}, qrLink = "" } = {}) => {
  const selloBlock = (label, value) => ({
    margin: [0, 0, 0, 0.5],
    stack: [
      { text: label, style: "subheader", fontSize: pdfFz(4.5), margin: [0, 0, 0, 0] },
      { text: value || "-", fontSize: pdfFz(3.2), lineHeight: 0.9, color: PDF_COLORS.ink },
    ],
  });

  const cajaCompacta = {
    ...lineLayoutsV2.cajaLimpia,
    paddingTop: () => 4,
    paddingBottom: () => 4,
    paddingLeft: () => 8,
    paddingRight: () => 8,
  };

  const fiscalKv = [
    { label: "Folio Fiscal (UUID):", value: dataExtra.uuid },
    { label: "No. de Serie del CSD:", value: dataExtra.noCertificadoCFDI },
    { label: "No. de Serie del CSD del SAT:", value: dataExtra.noCertificadoSAT },
    { label: "Fecha y hora de certificación:", value: dataExtra?.fechaTimbrado || dataSat?.Fecha || "-" },
  ];

  return {
    margin: [0, 2, 0, 0],
    stack: [
      {
        table: {
          widths: ["*"],
          body: [
            [
              {
                border: [false, false, false, false],
                columns: [
                  ...(qrLink
                    ? [
                        {
                          width: 78,
                          stack: [
                            { ...qrCanvasNode(qrLink, 74, { quietZone: 2 }), margin: [2, 0, 2, 0] },
                            { text: "Validación SAT", style: "textoChicoData", alignment: "center", margin: [0, 2, 0, 0] },
                          ],
                        },
                      ]
                    : []),
                  {
                    width: "*",
                    margin: [6, 0, 0, 0],
                    stack: [
                      ...kvRows(fiscalKv, { labelWidth: "auto", fontSize: pdfFz(5.5), columnGap: 4, rowMargin: 0.25 }),
                      {
                        margin: [0, 2, 0, 0],
                        stack: [
                          selloBlock("Sello digital del CFDI", dataExtra.selloCFDI),
                          selloBlock("Sello del SAT", dataExtra.selloSAT),
                          selloBlock("Cadena original del complemento de certificación digital del SAT", dataExtra.cadenaOriginalSAT),
                        ],
                      },
                    ],
                  },
                ],
                columnGap: 8,
              },
            ],
          ],
        },
        layout: cajaCompacta,
        margin: [0, 0, 0, 0],
      },
      {
        text: "Este documento es una representación impresa de un CFDI",
        style: "textoChicoData",
        alignment: "center",
        margin: [0, 2, 0, 0],
      },
    ],
  };
};

export default PDFCfdiFooterV2;
